var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-footer-wrapper"
  }, [_c("section", {
    staticClass: "app-footer area"
  }, [_c("section", {
    staticClass: "app-footer__left"
  }, [_c("section", {
    staticClass: "friendly-link"
  }, [_c("label", [_vm._v("友情链接")]), _vm._l(_vm.friendLinks, function (item, index) {
    return _c("span", {
      key: index,
      staticClass: "link"
    }, [_c("a", {
      attrs: {
        href: item.link,
        target: "_blank"
      }
    }, [_c("span", [_vm._v(_vm._s(item.name))])])]);
  })], 2), _c("section", {
    staticClass: "copyright"
  }, [_c("span", [_vm._v(_vm._s(_vm.companyInfo.copyRight))]), _c("span", {
    on: {
      click: _vm.jumpToGov
    }
  }, [_vm._v(_vm._s(_vm.companyInfo.ICP))]), _c("span", [_vm._v(_vm._s(_vm.companyInfo.filingNo))])])]), _c("section", {
    staticClass: "app-footer__right"
  }, [_c("section", {
    staticClass: "qrcode"
  }, [_c("img", {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: require("@/assets/images/qrcode.png"),
      expression: "require('@/assets/images/qrcode.png')"
    }],
    attrs: {
      alt: ""
    }
  })]), _c("section", {
    staticClass: "contact"
  }, [_c("section", {
    staticClass: "tel"
  }, [_c("label", [_vm._v("客服电话")]), _c("span", [_vm._v(_vm._s(_vm.companyInfo.customerService))])]), _c("section", {
    staticClass: "mail"
  }, [_c("label", [_vm._v("联系邮箱")]), _c("a", {
    attrs: {
      href: `mailto:${_vm.companyInfo.email}`
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.companyInfo.email))])])])])])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };